import { IDefault } from "../default.type";

export class GroupStatic {
    static administrators: IDefault = { id: "280ae506-8fd1-42b3-9548-f818cf7a0331", name: "Administradores" };
}
